import React from 'react';

// Img component that takes isAmp to render amp images if necessary
// withRetina assumes another asset with format <src url>@2x.png
const Img = ({
  src,
  isAmp = false,
  height,
  width,
  alt,
  layout = '',
  withRetina = false, // can also just pass srcSet
  ...props
}) =>
  isAmp ? (
    <amp-img
      src={src}
      srcset={
        withRetina ? `${src} 1x, ${src.slice(0, -4)}@2x.png 2x` : undefined
      }
      alt={alt}
      height={height}
      width={width}
      layout={layout || 'fixed'}
      {...props}
    />
  ) : (
    <img
      src={src}
      srcSet={
        withRetina ? `${src} 1x, ${src.slice(0, -4)}@2x.png 2x` : undefined
      }
      alt={alt}
      height={!isAmp && layout === 'responsive' ? '100%' : height}
      width={!isAmp && layout === 'responsive' ? '100%' : width}
      {...props}
    />
  );

export default Img;
